import getStore from '../bundles';

export default getStore();
